import markdownService from '@/taskpane/common/markdown'
import {
  officeApiItem_BodyAppendOnSendAsync,
  officeApiItem_BodyGetAsync,
  officeApiItem_BodyPrependAsync,
  officeApiItem_BodySetAsync,
  officeApiItem_BodySetSelectedDataAsync,
} from './async/office-api-body-async'
import officeApiIsRequirementSetSupported from './async/infrastructure/office-api-is-requirement-set-supported'
import configuration from '@/taskpane/common/configuration'

export async function officeBody(convertToMarkdown: boolean, defaultValue?: string): Promise<string> {
  const body = await officeApiItem_BodyGetAsync(Office.CoercionType.Html, defaultValue)

  if (!body) {
    return officeApiItem_BodyGetAsync(Office.CoercionType.Text, defaultValue)
  } else if (convertToMarkdown) {
    const markdownBody = markdownService().toMarkdown(body, false)
    return markdownBody
  } else {
    return body
  }
}

export async function officeEmailBlastId(): Promise<string> {
  const body = await officeBody(false)

  const idLength = 24
  const emailBlastIdLocation = body.indexOf(configuration.EMAIL_BLAST_ID_TAG)

  if (emailBlastIdLocation > 0) {
    const offset = configuration.EMAIL_BLAST_ID_TAG.length
    const id = body.substring(emailBlastIdLocation + offset, emailBlastIdLocation + offset + idLength)

    return id
  } else {
    return ''
  }
}

export function officeAppendOnSendSupported(): boolean {
  return officeApiIsRequirementSetSupported('1.9') && Office.context.mailbox.item.body.appendOnSendAsync !== undefined
}

export async function officeCancelAppendOnSend(): Promise<boolean> {
  if (!officeAppendOnSendSupported()) {
    return false
  }

  return officeApiItem_BodyAppendOnSendAsync(null)
}

const exportFunctions = {
  get: officeBody,
  getEmailBlastId: officeEmailBlastId,
  set: officeApiItem_BodySetAsync,
  prepend: officeApiItem_BodyPrependAsync,
  appendOnSend: officeApiItem_BodyAppendOnSendAsync,
  appendOnSendCancel: officeCancelAppendOnSend,
  appendOnSendSupported: officeAppendOnSendSupported,
  setSelectedData: officeApiItem_BodySetSelectedDataAsync,
}

export default exportFunctions
